import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ControlledMenu, useMenuState } from "@szhsin/react-menu";
import React from "react";
import cls from "./button-dropdown.module.scss";
import { MenuDropdownContext, usePortalContainer } from "./MenuContext";
import { SubMenu } from "./SubMenu";
import { MenuItem } from "./MenuItem";
export function ContextMenu(props) {
    const { children, menu, menuClassName = cls.menu, menuItemClassName = cls.menuItem, menuItemHoverClassName = cls.menuItemHover, menuItemDisabledClassName = cls.menuItemDisabled, menuItemWithSubMenuClassName = cls.menuItemWithSubMenu, ...rest } = props;
    const [{ state }, setOpen] = useMenuState({ initialMounted: false, transition: props.transition, unmountOnClose: true });
    const [anchorPoint, setAnchorPoint] = React.useState({ x: 0, y: 0 });
    const child = React.Children.only(children);
    const onContextMenu = React.useCallback((e) => {
        e.preventDefault();
        setAnchorPoint({ x: e.clientX, y: e.clientY });
        setOpen(true);
    }, [setOpen]);
    const clone = React.cloneElement(child, { onContextMenu });
    const container = usePortalContainer(state);
    return _jsxs(MenuDropdownContext.Provider, { value: { menuClassName, menuItemClassName, menuItemHoverClassName, menuItemDisabledClassName, menuItemWithSubMenuClassName }, children: [clone, _jsx(ControlledMenu, { ...rest, menuClassName: menuClassName, anchorPoint: anchorPoint, state: state, onClose: () => setOpen(false), portal: { target: container }, initialMounted: false, unmountOnClose: true, children: menu })] });
}
ContextMenu.SubMenu = SubMenu;
ContextMenu.MenuItem = MenuItem;
